import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BellNotificationAlarmOutline = createIcon({
  displayName: 'BellNotificationAlarmOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M9.66 18.18v.48l-.001 0c-.01 1.28 1.04 2.33 2.33 2.33 0 0 0-.001 0-.001h0l-.01-.001c1.28 0 2.33-1.05 2.33-2.34 0-.01 0-.01 0-.01v-.48" />
        <path d="M17.57 18.18h-.01c1.06 0 1.92-.87 1.92-1.93 0 0 0-.001 0-.001v0l0 0c-.01-.54-.22-1.06-.6-1.45l-1.28-1.28V9.724v-.001c0-3.11-2.52-5.63-5.625-5.63 0 0-.001 0-.001 0v0l-.01 0c-3.11 0-5.63 2.51-5.63 5.62 0 0 0 0 0 0V13.5l-1.28 1.27 0-.01c-.39.38-.6.9-.6 1.44v0l0-.01c-.01 1.06.86 1.92 1.92 1.92 0 0 0 0 0 0h11.15Z" />
        <path d="M22.02 3l-2 1.33" />
        <path d="M23 9l-1.98 0" />
        <path d="M1.98 3l2 1.33" />
        <path d="M1 9l1.98 0" />
      </g>
    </>
  ),
})

const BellNotificationAlarm: FC<IconProps> = (props) => {
  return <CustomIcon as={BellNotificationAlarmOutline} {...props} />
}

export default memo(BellNotificationAlarm)
